import React from "react";

const Section = (props) => {
  const bgClass = props.bg === 'gray' ? 'section--bg-gray' : '';
  const alignClass = props.align ? `section--align-${props.align}` : '';
  const typeClass = props.type ? `section--type-${props.type}` : '';

  return (
    <section className={`section ${bgClass} ${alignClass} ${typeClass}`.trim()}>
      <div className="container section__container">
        {props.children}
      </div>
    </section>
  )
};

export default Section;
